import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import { useTypedProjectCostContext } from './useTypedProjectCostContext';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `nav-link${isActive ? ' active' : ''}`;

const ProjectsCostShell: React.FC = () => {
  const { loading, saving, loadSnapshot } = useTypedProjectCostContext<{
    loading: boolean;
    saving: boolean;
    loadSnapshot: () => Promise<void>;
  }>();

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <nav aria-label="breadcrumb" className="cost-breadcrumb mb-1">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/projects">Projetos</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Gerenciamento de custo
              </li>
            </ol>
          </nav>
          <h2 className="mb-1">Gerenciamento de custo</h2>
          <small className="text-muted">
            Cadastros centralizados e análise de custos para projetos Jira.
          </small>
        </div>
        <div className="d-flex gap-2">
          <Button variant="outline-primary" onClick={() => void loadSnapshot()} disabled={loading || saving}>
            Atualizar
          </Button>
          <LinkContainer to="/projects/costs/analise">
            <Button variant="primary">Analisar custos</Button>
          </LinkContainer>
        </div>
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink end to="/projects/costs" className={navLinkClass}>
            Visão geral
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects/costs/analise" className={navLinkClass}>
            Análise
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects/costs/historico" className={navLinkClass}>
            Histórico
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects/costs/configuracoes" className={navLinkClass}>
            Configurações
          </NavLink>
        </li>
      </ul>

      <Outlet />
    </>
  );
};

export default ProjectsCostShell;
